<div mat-dialog-content>{{message}}</div>
<div mat-dialog-actions class="button-position">
  <button mat-button mat-dialog-close class="button-ok">{{Ok}}</button>
</div>